import React, { useContext, useEffect, useMemo, useState } from "react";

import { Button, Grid, Box } from "@mui/material";
import Alert from '@mui/material/Alert';
import Stack from '@mui/material/Stack';
import { Link } from 'react-router-dom'

import { apiGet } from "app/Services/ApiService";
import { contractorApiUrls } from "common/ApiUrls";
import SubContractorDashboard from "components/SubContractorDashboard";
export default function Dashboard() {
    return (
        <SubContractorDashboard path={"/contractor"} >
        </SubContractorDashboard>
    );
}

